import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-gray-200 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="md:flex md:items-start md:justify-between gap-8">
          {/* Brand Section */}
          <div className="mb-8 md:mb-0 md:flex-1">
            <div className="flex items-center space-x-3">
              <div className="bg-indigo-500/20 p-2 rounded-full">
                <img
                  className="w-8 h-8 rounded-full"
                  src="/sitelogo.jpeg"
                  aria-hidden
                ></img>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-white">HappyU</h3>
                <p className="text-sm text-gray-400">
                  Tools to help you breathe, reflect, and recharge every day.
                </p>
              </div>
            </div>
            <p className="mt-4 text-sm text-gray-400 max-w-sm leading-relaxed">
              Built with care — join our community for guided exercises, mental
              wellness tools, and positive reminders to take a pause.
            </p>
          </div>

          {/* Links */}
          <div className="mb-8 md:mb-0 md:flex-1 text-left">
            <h4 className="text-sm font-semibold mb-3 text-white uppercase tracking-wider">
              Explore
            </h4>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-1 text-sm text-gray-400">
              <li>
                <a className="hover:text-indigo-400 transition" href="#">
                  Home
                </a>
              </li>
              <li>
                <a className="hover:text-indigo-400 transition" href="#">
                  Features
                </a>
              </li>
              <li>
                <a className="hover:text-indigo-400 transition" href="#">
                  Exercises
                </a>
              </li>
              <li>
                <a className="hover:text-indigo-400 transition" href="#">
                  About
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 border-t border-gray-700 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-gray-500">
            &copy; {new Date().getFullYear()}{" "}
            <span className="text-gray-300">HappyU</span>. All rights reserved.
          </div>

          {/* Socials */}
          <div className="flex items-center space-x-3">
            {[
              {
                name: "Twitter",
                icon: (
                  <path d="M19 7.5c.01.14.01.29.01.43 0 4.4-3.36 9.48-9.48 9.48A9.42 9.42 0 0 1 2 15.6a6.68 6.68 0 0 0 .78.04 6.7 6.7 0 0 0 4.15-1.43 3.35 3.35 0 0 1-3.13-2.32c.52.08 1.04.06 1.56-.06A3.35 3.35 0 0 1 4.6 8.7v-.04c.45.25.98.4 1.53.42A3.35 3.35 0 0 1 3.3 6.25c0-.72.2-1.4.55-1.99a9.52 9.52 0 0 0 6.9 3.5c-.06-.24-.09-.49-.09-.75A3.35 3.35 0 0 1 14.6 4c1.03 0 1.95.43 2.6 1.12a6.63 6.63 0 0 0 2.12-.8 3.34 3.34 0 0 1-1.47 1.84 6.66 6.66 0 0 0 1.92-.52 6.98 6.98 0 0 1-1.67 1.73z" />
                ),
              },
              {
                name: "Instagram",
                icon: (
                  <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 6.2A4.8 4.8 0 1 0 16.8 13 4.8 4.8 0 0 0 12 8.2zM18.5 6a1.1 1.1 0 1 0 1.1 1.1A1.1 1.1 0 0 0 18.5 6z" />
                ),
              },
              {
                name: "GitHub",
                icon: (
                  <path d="M12 .5A11.5 11.5 0 0 0 .5 12c0 5.08 3.29 9.39 7.86 10.9.57.1.78-.25.78-.56 0-.28-.01-1.02-.02-2-3.2.7-3.88-1.54-3.88-1.54-.52-1.31-1.28-1.66-1.28-1.66-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.2 1.77 1.2 1.03 1.77 2.7 1.26 3.36.97.1-.76.4-1.26.73-1.55-2.56-.29-5.26-1.28-5.26-5.7 0-1.26.45-2.29 1.2-3.1-.12-.3-.52-1.51.11-3.15 0 0 .98-.31 3.2 1.19a11.1 11.1 0 0 1 2.92-.39c.99 0 1.99.13 2.92.39 2.22-1.5 3.2-1.19 3.2-1.19.63 1.64.23 2.85.11 3.15.75.81 1.2 1.84 1.2 3.1 0 4.43-2.7 5.41-5.27 5.69.41.36.77 1.08.77 2.18 0 1.57-.01 2.84-.01 3.23 0 .31.21.67.79.56A11.5 11.5 0 0 0 23.5 12 11.5 11.5 0 0 0 12 .5z" />
                ),
              },
            ].map((s) => (
              <a
                key={s.name}
                href="#"
                aria-label={s.name}
                className="p-2 rounded-md bg-gray-700 hover:bg-indigo-500/20 text-gray-400 hover:text-indigo-400 transition-all duration-200"
              >
                <svg
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden
                >
                  {s.icon}
                </svg>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
